// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"BlockLoader_loaderContainer__14UoA"};